// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f2e1dfb593c688a8","3583":"723d83f19b77d8d2","4087":"9c5901a4b732c674","5533":"9c5901a4b732c674","7357":"eb767bb0dca762ce","8751":"9c5901a4b732c674"}[chunkId] + ".css";
};